import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e8a81144"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Game Invitation Request", -1))
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "timer" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "footer-buttons" }
const _hoisted_7 = { class: "clearfix" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", null, _toDisplayString(_ctx.modalText), 1),
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.elapsedTime) + " s", 1),
        _createElementVNode("p", null, "Game Type: " + _toDisplayString(_ctx.getGameType(_ctx.newGame.gameType)), 1),
        _createElementVNode("p", null, "Shot Time Limit: " + _toDisplayString(_ctx.newGame.timeLimit) + " (seconds)", 1),
        (_ctx.newGame.gameType === 1)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Wager: " + _toDisplayString(_ctx.newGame.wager) + " " + _toDisplayString(_ctx.newGame.network), 1))
          : _createCommentVNode("", true),
        (_ctx.newGame.gameType === 1)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Network: " + _toDisplayString(_ctx.getNetwork(_ctx.newGame.network)), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            type: "button",
            class: "confirmbtn",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onAccept && _ctx.onAccept(...args)))
          }, " Accept "),
          _createElementVNode("button", {
            type: "button",
            class: "deletebtn",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onDecline && _ctx.onDecline(...args)))
          }, " Decline ")
        ])
      ])
    ]),
    _: 1
  }))
}